import { Location } from "history";
import { isBrowser } from "./browser.helper";

export function getPath(location: Location, includeParameters = true): string {
    return location.pathname + (includeParameters ? location.search : "");
}

export const givenURLIsPartOfLocation = (url: string, location: Location): boolean => getPath(location).indexOf(url) >= 0;

export const givenURLIsIdenticalToLocation = (
    url: string,
    location: Location,
    includeParameters = false,
): boolean => getPath(location, includeParameters) === url;

export interface IParamSet {
    key: string;
    value: string;
}

export function getUrlParams(path?: string): IParamSet[] {
    if (isBrowser || path) {
        let pairs: string[] = [];

        if (path) {
            const search = path.split('?')[1] || '';
            pairs = removeTrailingSlash(search).split('&').filter(pair => !!pair);
        } else {
            pairs = removeTrailingSlash(location.search).replace('?', '').split('&').filter(pair => !!pair);
        }

        return pairs.map(pair => {
            const [key, value] = pair.split("=");
            return { key, value };
        })
    } else {
        return [] as IParamSet[];
    }
}

const trailingSlash = /\/$|\/(?=\?)|\/(?=#)/g;

/**
 * Removes trailing slashes from a URL.
 * @param url The URL to process.
 * @returns The URL without trailing slashes.
 */
export const removeTrailingSlash = (url: string) => url && url?.length > 1 ? url?.replace(trailingSlash, '') : url;
